import { render, staticRenderFns } from "./create-profile-step-2.vue?vue&type=template&id=30e673c4&scoped=true"
import script from "./create-profile-step-2.vue?vue&type=script&lang=js"
export * from "./create-profile-step-2.vue?vue&type=script&lang=js"
import style0 from "./create-profile-step-2.vue?vue&type=style&index=0&id=30e673c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e673c4",
  null
  
)

export default component.exports